import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { RichTextField, TextField } from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import { TextWidgetComponent } from '@content/ui/text-widget';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-text-widget-container',
  templateUrl: './text-widget.container.component.html',
  standalone: true,
  imports: [TextWidgetComponent, ContentSectionComponent],
})
export class TextWidgetContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly content = computed(() =>
    getField<RichTextField>(this.fields(), 'content')
  );

  readonly inverse = computed(
    () => this.rendering().params?.showInverse === '1'
  );
}
